import { useWindowSize } from 'react-use'

export const usrIsMobileScreenSize = (): boolean => {
  return useWindowSize().width <= 520 // Adjust breakpoint as needed
}
